import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, map, take } from 'rxjs';
import { selectIsAdmin, selectModuleAccess } from '@store/auth/auth.selectors';

/**
 * Guard que verifica acceso a un módulo según `role_module_access`.
 * Uso en rutas: canActivate: [permissionGuard], data: { permission: 'MAILING' }
 * Si no hay `permission` en data, deja pasar (rutas sin restricción de módulo).
 * Admin (idRole=1) siempre pasa.
 */
export const permissionGuard: CanActivateFn = (route) => {
  const required = route.data['permission'] as string | undefined;
  if (!required) return true;

  const store  = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(selectIsAdmin),
    store.select(selectModuleAccess),
  ]).pipe(
    take(1),
    map(([isAdmin, moduleAccess]) => {
      if (isAdmin) return true;
      const hasAccess = moduleAccess.some(a => a.moduleCode === required && a.canView);
      return hasAccess ? true : router.createUrlTree(['/dashboard']);
    })
  );
};
